
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M23.35 5.595c-.867-1.03-2.467-1.45-5.521-1.45H6.74c-3.124 0-4.75.447-5.614 1.544C.285 6.758.285 8.333.285 10.513v4.155c0 4.223.998 6.367 6.455 6.367H17.83c2.649 0 4.117-.37 5.066-1.28.974-.931 1.39-2.453 1.39-5.087v-4.155c0-2.3-.065-3.884-.936-4.918Zm-7.657 7.569-5.035 2.631a.774.774 0 0 1-1.133-.686V9.863a.774.774 0 0 1 1.13-.687l5.036 2.615a.774.774 0 0 1 .002 1.373Z","fill":"#E53935"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.285 .145)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    